import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt, faLanguage, faToolbox, faHeart, faBriefcase, faGraduationCap, faLink } from '@fortawesome/free-solid-svg-icons';
import { faGithub, faLinkedin, faYoutube, faUpwork, faTelegram, faFacebook, faTwitter, faInstagram, faMedium, faBehance, faDribbble, faStackOverflow, faAngellist, faQuora, faVimeo, faSoundcloud } from '@fortawesome/free-brands-svg-icons';

import '../styles/TemplateSix.css';

const TemplateSix = ({ template, onClick }) => {
    const linkIcons = {
        github: faGithub,
        linkedin: faLinkedin,
        youtube: faYoutube,
        upwork: faUpwork,
        telegram: faTelegram,
        facebook: faFacebook,
        website: faLink,
        portfolio: faLink, // Assume generic link icon
        twitter: faTwitter,
        instagram: faInstagram,
        medium: faMedium,
        behance: faBehance,
        dribbble: faDribbble,
        stackoverflow: faStackOverflow,
        angellist: faAngellist,
        quora: faQuora,
        vimeo: faVimeo,
        soundcloud: faSoundcloud
    };

    const linkText = {
        github: 'GitHub',
        linkedin: 'LinkedIn',
        youtube: 'YouTube',
        upwork: 'Upwork',
        telegram: 'Telegram',
        facebook: 'Facebook',
        website: 'Website',
        portfolio: 'Portfolio',
        twitter: 'Twitter',
        instagram: 'Instagram',
        medium: 'Medium',
        behance: 'Behance',
        dribbble: 'Dribbble',
        stackoverflow: 'Stack Overflow',
        angellist: 'AngelList',
        quora: 'Quora',
        vimeo: 'Vimeo',
        soundcloud: 'SoundCloud'
    };

    return (
        <div className="template-six-container" onClick={() => onClick(template?.id)}>
            <div className="template-six-header">
                {template?.image && <img src={template?.image} alt={template?.personName} className="template-six-image" />}
                <div className="template-six-name-title">
                    {template?.name && <h1 className="template-six-name" >{template?.name}</h1>}
                </div>
            </div>
            <div className="template-six-body">
                <div className="template-six-column-left">
                    {template?.aboutMe && (
                        <div className="template-six-section">
                            <h3>About Me</h3>
                            <strong>{template?.aboutMe}</strong>
                        </div>
                    )}
                    {template?.skills && template?.skills.length > 0 && (
                        <div className="template-six-section">
                            <h3>Skills</h3>
                            <ul>
                                {template?.skills.map((skill, index) => (
                                    <li key={index}>{skill}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                    {template?.languages && template?.languages.length > 0 && (
                        <div className="template-six-section">
                            <h3>Languages</h3>
                            <ul>
                                {template?.languages.map((language, index) => (
                                    <li key={index}>{language}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                    {template?.hobbies && template?.hobbies.length > 0 && (
                        <div className="template-six-section">
                            <h3>Interests</h3>
                            <ul>
                                {template?.hobbies.map((hobby, index) => (
                                    <li key={index}>{hobby}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
                <div className="template-six-column-right">


                    {template.contact && (
                        <div className="template-six-section">
                            <h3>Contact</h3>
                            {template.contact.phone && <p><FontAwesomeIcon icon={faPhone} /> {template.contact.phone}</p>}
                            {template.contact.email && <p><FontAwesomeIcon icon={faEnvelope} /> {template.contact.email}</p>}
                            {template.contact.address && <p><FontAwesomeIcon icon={faMapMarkerAlt} /> {template.contact.address}</p>}
                        </div>
                    )}

                    {template?.workExperience && template?.workExperience.length > 0 && (
                        <div className="template-six-section">
                            <h3>Work Experience</h3>
                            {template?.workExperience.map((experience, index) => (
                                <div key={index} className="template-six-experience-item">
                                    <p className="template-six-role">{experience.role}</p>
                                    <p className="template-six-company-location">{experience.company} / {experience.location}</p>
                                    <p className="template-six-date">
                                        {experience.location && (
                                            <p className="location">
                                                (
                                                {experience.startDate && new Date(experience.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                                {experience.endDate !== "Present" ? new Date(experience.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                                )
                                            </p>
                                        )}
                                    </p>
                                    <p className="template-six-description">{experience.description}</p>
                                </div>
                            ))}
                        </div>
                    )}

                    {template?.education && Array.isArray(template?.education) && template?.education.length > 0 && (
                        <div className="template-six-section">
                            <h3>Education</h3>
                            {template?.education.map((edu, index) => (
                                <div key={index} className="template-six-education-item">
                                    <p className="template-six-degree">{edu.degree}</p>
                                    <p className="template-six-institution">{edu.institution}</p>
                                    <p>
                                        (
                                        {edu.startDate && new Date(edu.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                        {edu.endDate !== "Present" ? new Date(edu.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                        )
                                    </p>
                                    <p className="view-template-eight-institution">{edu.description}</p>
                                </div>
                            ))}
                        </div>
                    )}

                    {template.certificates && template.certificates.length > 0 && (
                        <div className="template-six-section">
                            <h3>Certificates</h3>
                            {template.certificates.map((cert, index) => (
                                <div key={index} className="template-six-education-item">
                                    <p className="template-six-degree">Title: {cert.title}</p>
                                    <p className="template-six-institution">Institution: {cert.institution}</p>
                                    <p className="template-six-date">
                                        Date Received: {new Date(cert.DateReceived).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                                    </p>
                                </div>
                            ))}
                        </div>
                    )}


                    {template.softwareSkills && template.softwareSkills.length > 0 && (
                        <div className="template-six-section template-six-education-item">
                            <h3>Software Skills</h3>
                            <div className="software-skills-wrapper">
                                {template.softwareSkills.map((skill, index) => (
                                    <div key={index} className="software-skill-item">
                                        <p>{skill}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}


                    {template?.links && template?.links.length > 0 && (
                        <div className="template-six-section template-six-education-item">
                            <h3>Links:</h3>
                            <div className="software-skills-wrapper">

                                {template.links.map(([key, value]) => (
                                    <p key={key} className="template-three-link">
                                        <FontAwesomeIcon icon={linkIcons[key] || faLink} /> <a href={value} target="_blank" rel="noopener noreferrer"> <span className="template-three-link-text">{linkText[key]}</span></a>
                                    </p>
                                ))}
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
};

export default TemplateSix;
